import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import Package from './Package'

const PACKAGE_LIMIT = 4
const Packages = ({
  isLimited,
  isHalf,
}) => {
  const packages = useSelector(state => state.asset.packages)

  const limit = isLimited ? PACKAGE_LIMIT : packages.length

  return (
    <ul className='asset-list m-0 p-0'>
      {packages.slice(0, limit).map(asset => (
        <Package key={asset.id} {...{ asset, isHalf }} />
      ))
      }
    </ul>
  )
}

export default Packages

Packages.propTypes = {
  isHalf: PropTypes.bool,
  isLimited: PropTypes.bool,
}
